import { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TextField from '../FormLegacy/FormFieldsV2/TextField'
import InformationPopup from '../Popups/InformationPopup'

import AnswerButton from './components/AnswerButton'
import AnswerTimePicker from './components/AnswerTimePicker'
import AnswerImagePicker from './components/AnswerImagePicker'

const BookingForm = (props) => {
  const { questions, errors, values, touched, onAnswerPress, onInputChange } = props
  const { t } = useTranslation(['booking'])
  const [visibleSupportPopup, setVisibleInfoPopup] = useState(false)
  const [contentModal, setContentModal] = useState('')

  const openInformationModal = (content) => {
    setVisibleInfoPopup(true)
    setContentModal(content)
  }

  return (
    <div className="booking-form-container">
      <div className="service-questions-container">
        {questions.map((question) => (
          <div key={question.id} className="service-question">
            <div className="service-question-header">
              <span className="question-title">{question.title}</span>
              {question.selectType === 'multiple' ? (
                <span className="service-question-tip" style={{ marginRight: '3px' }}>
                  {t('booking:form.selectAllThatApply')}
                </span>
              ) : null}
              {!question.isRequired ? (
                <span className="service-question-tip">{t('booking:form.optional')}</span>
              ) : null}
              {question.modal ? (
                <div
                  className="additional-information-icon"
                  onClick={() => openInformationModal(question.modal)}
                >
                  {t('booking:form.infoIcon')}
                </div>
              ) : null}
            </div>

            {errors && errors[question.customId] && touched[question.customId] && (
              <div className="error-message">{t('booking:form.errorMessage')}</div>
            )}

            <div
              className={`service-question-answers-container ${
                question.answers.length === 1
                  ? 'single-long-button'
                  : question.answers.length % 3 === 0
                    ? 'last-long-button'
                    : ''
              }`}
            >
              {question.answers.map((answer) => {
                switch (answer.type) {
                  case 'button':
                    return (
                      <AnswerButton
                        key={answer.customId}
                        answer={answer}
                        question={question}
                        onAnswerPress={onAnswerPress}
                        values={values}
                      />
                    )
                  case 'time picker':
                    return (
                      <AnswerTimePicker
                        key={answer.customId}
                        answer={answer}
                        question={question}
                        onInputChange={onInputChange}
                        values={values}
                      />
                    )
                  case 'input':
                    return (
                      <TextField
                        key={answer.customId}
                        name={'zipCode'}
                        placeholder={''}
                        onChange={(e) => onInputChange(question, answer, e.target.value)}
                      />
                    )
                  case 'image':
                    return (
                      <AnswerImagePicker
                        key={answer.customId}
                        answer={answer}
                        question={question}
                        onInputChange={onInputChange}
                      />
                    )
                  default:
                    return null
                }
              })}
            </div>
          </div>
        ))}
      </div>
      <InformationPopup
        isOpen={visibleSupportPopup}
        cancelCallback={() => setVisibleInfoPopup(false)}
        text={contentModal}
      />
    </div>
  )
}

BookingForm.propTypes = {
  questions: PropTypes.array,
  errors: PropTypes.object,
  touched: PropTypes.object,
  values: PropTypes.object,
  onAnswerPress: PropTypes.func,
  onInputChange: PropTypes.func,
}

export default BookingForm
